{
    "warning": "警告！",
    "message": "請勿輸入或貼上你不了解的代碼。\n使用此操作介面可能會讓攻擊者假冒你的身分，並使用 Self-XSS 攻擊方式來竊取你的資訊。"
}
